import { PasswordReset } from "@cleeng/mediastore-sdk";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

function PasswordResetPage() {
  const navigate = useNavigate()
  const handleSuccess = () => {
    toast('Please check your email and follow the link to finish resetting your password');
    navigate('/')
  }
  return (
    <>
      <PasswordReset onSuccess={handleSuccess} />
    </>
  );
}

export default PasswordResetPage;
